export function request(input, init = {}) {
    init.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        ...init.headers,
    }
    return fetch(input, init)
}
